// extracted by mini-css-extract-plugin
module.exports = {"card":"contractAdditionalInfoList_card__146n7"};